module.exports = __webpack_public_path__ + "img/icon_10.e5f80947.svg";